import React, { useRef } from 'react';
import { Trip } from '@/types';
import { Button } from '@mui/material';
import { Download } from '@mui/icons-material';
import TripDashboardSection from '../TripDashboardSection';
import TripOverviewStats from '@/components/trip/TripOverviewStats';
import ImportExportFeature from '@/components/trip/ImportExportFeature';
import { useI18n } from '@/hooks/useI18n';

interface TripOverviewPageProps {
  trip: Trip;
}

const TripOverviewPage: React.FC<TripOverviewPageProps> = ({ trip }) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { t } = useI18n();

  return (
    <>
      <TripDashboardSection
        icon="📊"
        title={t('trip.dashboard.tabs.overview')}
        subtitle={`📍 ${trip.destination}`}
        description={t('trip.pages.overview.description')}
        primaryAction={{
          icon: <Download />,
          onClick: () => {
            triggerRef.current?.click();
          },
          label: t('trip.pages.overview.importExport')
        }}
      >
        <TripOverviewStats trip={trip} />
      </TripDashboardSection>

      <ImportExportFeature 
        trip={trip} 
        trigger={
          <Button 
            ref={triggerRef}
            style={{ display: 'none' }}
          >
            {t('trip.pages.overview.hidden')}
          </Button>
        }
      />
    </>
  );
};

export default TripOverviewPage;
